export const environment = {
    production: true,
    apiBaseUrl: '#{ApiBaseUrl}#',
    environment: '#{Environment}#',
    acceptJsScriptUrl: '#{AcceptJsScriptUrl}#'
};